export default "__VITE_ASSET__BqSvNqiv__"